import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Image from "components/widgets/Image";
import styled from "@emotion/styled";
import TeamMemberView from './TeamMemberView';

const PREFIX = 'TeamPanel';

const classes = {
    img: `${PREFIX}-dealer-img`,
    flex: `${PREFIX}-flex`,
    logo: `${PREFIX}-logo`,
    right: `${PREFIX}-right`,
    border: `${PREFIX}-border`,
    container: `${PREFIX}-container`
}

const StyledGrid = styled(Grid)((
    {
        theme
    }
) => {
    return {
        marginTop: 50,
        background: 'rgba(237, 237, 237, 0.4)',
        [`& .${classes.img}`]: {
            marginTop: 50,
            paddingLeft: 10
        },
        [`& .${classes.flex}`]: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: 10
        },
        [`& .${classes.logo}`]: {
            height: 50,
            width: 50
        },
        [`& .${classes.right}`]: {
            color: theme.palette.secondary.main
        },
        [`& .${classes.container}`]: {
            padding: 20,
        },
        [`& .${classes.border}`]: {
            width: 150,
            marginBottom: 10,
            borderTop: `3px solid ${theme.palette.secondary.main}`,
            float: 'left'
        },
    }
});

const TeamPanel = () => {
    return (
        <StyledGrid>
            <Grid item xs={12} className={classes.container}>
                <Box className={classes.flex}>
                    <Image
                        alt="Banner Image"
                        src='/static/images/ReinventLogo.png'
                        className={classes.logo}
                    />
                    <Typography variant='h1' color="#213E98">The Reinvent <span className={classes.right}>Leadership</span> team</Typography>
                </Box>
                <hr className={classes.border} />
            </Grid>
            <Grid container item xs={12} className={classes.img} spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Rob Gadek"
                        title="CGO"
                        src="/static/images/team/rob_gadek.png"
                        alt="Rob Gadek"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Brian Michel"
                        title="CRO"
                        src="/static/images/team/brian_michel.png"
                        alt="Brian Michel"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Bob Kirkland"
                        title="CCO"
                        src="/static/images/team/bob_kirkland.png"
                        alt="Bob Kirkland"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Allan Wick"
                        title="VP, Product and Engineering"
                        src="/static/images/team/allan_wick.png"
                        alt="Allan Wick"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Dean Stojka"
                        title="Co-Founder"
                        src="/static/images/team/dean_stojka.png"
                        alt="Dean Stojka"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Todd Wilkins"
                        title="Co-Founder"
                        src="/static/images/team/todd_wilkins.png"
                        alt="Todd Wilkins"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Paul Jones"
                        title="Co-Founder/Advisor"
                        src="/static/images/team/paul_jones.png"
                        alt="Paul Jones"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="David Revere"
                        title="West Coast Sales"
                        src="/static/images/team/david_revere.png"
                        alt="David Revere"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Scott Miller"
                        title="Advisor"
                        src="/static/images/team/scott_miller.png"
                        alt="Scott Miller"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Todd Docter"
                        title="Advisor"
                        src="/static/images/team/todd_docter.png"
                        alt="Todd Docter"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="John Stojka"
                        title="Advisor"
                        src="/static/images/team/john_stojka.png"
                        alt="John Stojka"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TeamMemberView
                        className={classes.img}
                        name="Brad Holister"
                        title="Advisor"
                        src="/static/images/team/brad_holister.png"
                        alt="Brad Holister"
                    />
                </Grid>
            </Grid>
        </StyledGrid>
    );
}

export default TeamPanel;